<template>
  <div class="wrap">
    <Nav :title="$t('user.basicInformation')" fixed safeAreaInsetTop placeholder />
    <div class="content">
      <div class="info_item">
        <div class="info_item_title">
          <div class="line"></div>
          <div class="text">{{ $t('user.title') }}</div>
        </div>
        <div class="info_item_cont">
          <div class="item">
            <div class="label">{{ $t('fullName') }}</div>
            <div class="value">{{ form.name }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('idNumber') }}</div>
            <div class="value">{{ form.idcard }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('gender') }}</div>
            <div class="value">{{ getGender(form.gender) }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('birthday') }}</div>
            <div class="value">{{ form.birthday }}</div>
          </div>
        </div>
      </div>
      <div class="info_item">
        <div class="info_item_title">
          <div class="line"></div>
          <div class="text">{{ $t('银行信息') }}</div>
        </div>
        <div class="info_item_cont">
          <div class="item">
            <div class="label">{{ $t('bank') }}</div>
            <div class="value">{{ form.bank }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('bankNumber') }}</div>
            <div class="value">{{ form.card }}</div>
          </div>
        </div>
      </div>
      <div class="info_item">
        <div class="info_item_title">
          <div class="line"></div>
          <div class="text">{{ $t('附加信息') }}</div>
        </div>
        <div class="info_item_cont">
          <div class="item">
            <div class="label">{{ $t('maritalStatus') }}</div>
            <div class="value">{{ getMaritalStatus(form.maritalStatus) }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('education') }}</div>
            <div class="value">{{ getEducation(form.education) }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('careerInformation') }}</div>
            <div class="value">{{ form.job }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('province') }}</div>
            <div class="value">{{ form.province }},{{ form.city }}</div>
          </div>
          <div class="item">
            <div class="label">{{ $t('address') }}</div>
            <div class="value">{{ form.address }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from "vant";
import Nav from "@/components/Navbar";
import { USER_LEVELAUTH } from "@/api";
export default {
  components: {
    [Icon.name]: Icon,
    Nav
  },
  data() {
    return {
      form: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getGender(index) {
      if (index == 0) return this.$t('female');
      return this.$t('male')
    },
    getMaritalStatus(index) {
      switch (index) {
        case 0:
          return this.$t('single')
          break;
        case 1:
          return this.$t('married')
          break;
        case 2:
          return this.$t('divorced')
          break;
        case 3:
          return this.$t('widowed')
          break;
        default:
          break;
      }
    },
    getEducation(index) {
      switch (index) {
        case 0:
          return this.$t('juniorHigh')
          break;
        case 1:
          return this.$t('middleSchool')
          break;
        case 2:
          return this.$t('highSchool')
          break;
        case 3:
          return this.$t('graduateAbove')
          break;
        case 4:
          return this.$t('none')
          break;
        default:
          break;
      }
    },
    async getData() {
      try {
        const res = await USER_LEVELAUTH({});
        this.form = { ...res.data.auth_data || {} }
      } catch (error) { }
    },
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: var(--newbg);

  .content {
    padding: calc(30rem / 16) calc(10rem / 16);

    .info_item {
      background-color: var(--white);
      margin-bottom: calc(30rem / 16);
      border-radius: 12px;
      box-shadow: 0px 4px 6px 0px rgba(25, 56, 188, 0.23);
      padding: 18px 15px;

      .info_item_title {
        display: flex;
        align-items: center;

        .line {
          width: 4px;
          height: 16px;
          border-radius: 100px;
          background: var(--btnColor);
        }

        .text {
          color: #3d3d3d;
          font-size: 14px;
          padding-left: 8px;
          font-weight: bold;
        }
      }

      .info_item_cont {
        padding: 12px;
      }

      .item {
        padding: calc(5rem / 16) 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: calc(14rem / 16);
        border-bottom: 1px dashed silver;

        .label {
          color: rgba(61, 61, 61, 0.8);
          line-height: calc(30rem /16);
        }

        .value {
          width: calc(150rem / 16);
          color: #3d3d3d;
          line-height: calc(30rem /16);
          padding: 0 0 0 calc(15rem / 16);
          text-align: right;
          display: flex;
          align-items: center;
          justify-content: end;
        }
      }
    }

    .info_item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>